export const headerBackground = () => {
    $(document).on('scroll', function () {
        if ($(window).scrollTop() <= 110) {
            $('.header--without-bg').removeClass('active');
        } else {
            $('.header--without-bg').addClass('active');
        }
    });
}
export const headerPositionWithBanner = () => {
    const topBanner = $('.top-banner');
    const header = $('.header');
    const pageWrapper = $('.new-version');

    if (topBanner.length !== 0) {
        header.css("top", topBanner.height());
        pageWrapper.css("padding-top", topBanner.height() + header.height());
    } else {
        header.css("top", 0);
        pageWrapper.css("padding-top", header.height());
    }
}


